import React from 'react';
import { isPreProd } from '../constants';

const defaultTitle =
  'Les Initiatives des Shifters pour la transition énergie-climat';
const defaultDescription =
  'Découvrez les projets et activités des Shifters pour contribuer à la décarbonation et engagez-vous dans la transition énergétique';

type SEOProps = {
  title?: string;
  description?: string;
  pathname?: string;
  children?: JSX.Element;
};

export const SEO = ({
  title = defaultTitle,
  description = defaultDescription,
  pathname,
  children,
}: SEOProps) => {
  const seo = {
    title: title,
    description: description,
    image: `https://initiatives.theshifters.org/share.png`,
    url: 'https://iniatitives.theshifters.org',
    twitterUsername: '@Les_shifters',
  };

  return (
    <>
      {isPreProd ? <meta name="robots" content="noindex, nofollow" /> : null}
      <title>{seo.title}</title>
      <meta httpEquiv="content-language" content="fr-fr" />
      <meta name="description" content={seo.description} />
      <meta property="og:title" content={title} />
      <meta name="image" content={seo.image} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
      <meta property="og:image" content={seo.image} />

      <meta name="twitter:card" content="summary" />
      <meta name="twitter:title" content={seo.title} />
      <meta name="twitter:url" content={seo.url} />
      <meta name="twitter:description" content={seo.description} />
      <meta name="twitter:image" content={seo.image} />
      <meta name="twitter:site" content={seo.twitterUsername} />
      {children}
    </>
  );
};
